import { TimelineStatus, useTimelineStatusMaxHeight } from '@components'

import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { getCurrentLocale } from '../../../../../../utils'
import { useVatDeclaration } from '../../../../context/vatDeclarationContext'
import { statusLabels } from '../../consts/statusLabels'
import { getSubmissionTimelineStatus } from '../../utils/getSubmissionTimelineStatus'
import { getUiStatus } from './utils/getUIStatus'

export const VatDeclarationTimeline = () => {
  const { t } = useTranslation()
  const locale = getCurrentLocale()

  const wrapperRef = useRef<HTMLDivElement>(null)

  const { submission, isLoading } = useVatDeclaration()
  const { maxHeight } = useTimelineStatusMaxHeight({ ref: wrapperRef, isLoading })

  const timeline = submission?.detail?.timeline

  if (!submission || !timeline || timeline.length === 0) {
    return null
  }

  return (
    <div ref={wrapperRef}>
      <TimelineStatus title={t('vat_declarations.timeline.title')} maxHeight={maxHeight}>
        <TimelineStatus.ItemsList>
          {timeline.map((submissionTimeline, index) => {
            const status = getSubmissionTimelineStatus({
              code: submissionTimeline.code,
              index,
              submission,
            })
            const uiStatus = getUiStatus(status)
            const titleKey = statusLabels[status]

            return (
              <TimelineStatus.Item
                key={submissionTimeline.id}
                date={submissionTimeline.statusAt}
                description={locale === 'nl_NL' ? submissionTimeline.status : submissionTimeline.statusEn}
                status={uiStatus}
                title={t(titleKey)}
              />
            )
          })}
        </TimelineStatus.ItemsList>
      </TimelineStatus>
    </div>
  )
}
